import React from 'react';
import OverlayMessage from './OverlayMessage';

const Success = (props) => {
  return <OverlayMessage {...props} iconName="Accept" />;
};

export default Success;



// WEBPACK FOOTER //
// ./src/app/components/MessageOverlay/Success.jsx